import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const SECTION = {
  GET_LIST: createActionTypes("GET_LISTA_SECTION"),
  GET_SECTION: createActionTypes("GET_SECTION"),
  SAVE_SECTION: createActionTypes("SAVE_SECTION"),
  DUPLICATE_SECTION: createActionTypes("DUPLICATE_SECTION"),

  GET_SECTION_HISTORY: createActionTypes("GET_SECTION_HISTORY"),
  GET_SECTION_HISTORY_LIST: createActionTypes("GET_SECTION_HISTORY_LIST"),
  GET_SECTION_ALL: createActionTypes("GET_SECTION_ALL"),

  GET_SECTION_PRODUCTS: createActionTypes("GET_SECTION_PRODUCTS"),
  GET_SECTION_SNIPPETS: createActionTypes("GET_SECTION_SNIPPETS"),

  GET_SECTION_PREVIEW: createActionTypes("GET_SECTION_PREVIEW"),

  POST_SECTION_DOWNLOAD_LIST: createActionTypes("POST_SECTION_DOWNLOAD_LIST"),

  LOAD_EMPTY: "LOAD_EMPTY_SECTION",
  CLEAN_MESSAGE: "CLEAN_MESSAGE_SECTION",
  DISABLE_LOADING_SECTION: "DISABLE_LOADING_SECTION",
  CLEAN_ID_SECTION_DUPLICATE: "CLEAN_ID_SECTION_DUPLICATE",
  CHANGE_PAGE_SIZE_SECTION: "CHANGE_PAGE_SIZE_SECTION",
};
